import { User } from './user';
import { LegFiJwtService } from '../../services/auth/legfi-jwt.service';
import moment from 'moment-timezone';
import Moment = moment.Moment;


export class PayabliBoardingSubmission
{
    id: number;
    canDelete: boolean;
    payabliAppLink: string;
    payabliAuthAppLink: string;
    payabliAppReferenceId: string;
    payabliAppId: string;
    organizationId: number;
    status: string;
    statusText: string;
    userId: number;
    createdAt: Moment;
    updatedAt: Moment;
    user: User;

    constructor(submission: any) {
        if (submission.id) {
            this.id = submission.id;
        }
        if (submission.canDelete) {
            this.canDelete = submission.canDelete;
        }
        if (submission.payabliAppLink) {
            this.payabliAppLink = submission.payabliAppLink;
        }
        if (submission.payabliAuthAppLink) {
            this.payabliAuthAppLink = submission.payabliAuthAppLink;
        }
        if (submission.payabliAppReferenceId) {
            this.payabliAppReferenceId = submission.payabliAppReferenceId;
        }
        if (submission.payabliAppId) {
            this.payabliAppId = submission.payabliAppId;
        }
        if (submission.organizationId) {
            this.organizationId = submission.organizationId;
        }
        if (submission.status) {
            this.status = submission.status;
        }
        if (submission.statusText) {
            this.statusText = submission.statusText;
        }
        if (submission.userId) {
            this.userId = submission.userId;
        }

        const timezone = LegFiJwtService.getTimezone();
        if (submission.createdAt) {
            this.createdAt = moment.utc(submission.createdAt, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }
        if (submission.updatedAt) {
            this.updatedAt = moment.utc(submission.updatedAt, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }

        // relationships
        if (submission.user) {
            this.user = new User(submission.user);
        }
    }
}
